import { render } from "./Web.vue?vue&type=template&id=bf181af0"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Web.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf181af0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf181af0', __exports__)) {
    api.reload('bf181af0', __exports__)
  }
  
  module.hot.accept("./Web.vue?vue&type=template&id=bf181af0", () => {
    api.rerender('bf181af0', render)
  })

}


export default __exports__